module.exports = __webpack_public_path__ + "static/media/supernovas.a7139ae2.png";